import { DataTypeColumn } from '../../Common/commonColumnHelpers'
import { HOTEL_AMENITIES_COLUMN } from 'constants/hotelAmenities'
import {
  getGooglePlaceDoorBaseColumns,
  GooglePlaceDoorBaseWithProxyFields,
} from '../GooglePlaceBase/GooglePlaceDoorsBaseColumnsInfo'

// Lodging-only door columns get spread alongside the shared base, mirroring
// LodgingColumnsInfo.
export const LODGING_DOORS_COLUMNS = {
  ...getGooglePlaceDoorBaseColumns('Lodging'),
  hotel_amenities: HOTEL_AMENITIES_COLUMN,
} satisfies Partial<
  Record<
    keyof GooglePlaceDoorBaseWithProxyFields | 'hotel_amenities',
    DataTypeColumn
  >
>
